"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var EditorTypes_1 = require("./../EditorTypes");
var BehaviourBuilder_1 = require("./BehaviourBuilder");
var Utils_1 = require("../Utils");
var ImageActions_1 = require("./ImageActions");
var WidgetActions_1 = require("./WidgetActions");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
exports.default = (function (di) {
    var dragStore = di.get("dragStore");
    var dropLocationStore = di.get("dropLocationStore");
    var mediaUsageReporter = di.get("mediaUsageReporter");
    var usingFeature = di.get("usingFeature");
    var editorTelemetry = di.get("editorTelemetry");
    var blockStore = di.get("blockStore");
    var contentSidebarTelemetry = di.get("contentSidebarTelemetry");
    return {
        onEnter: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("imageOnEnter")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Enter)
            .selectionIsCollapsed()
            .inBlockType(EditorTypes_1.BlockType.Image)
            .doAction(function (event, editor) {
            event.preventDefault();
            var didOpenGallery = (0, ImageActions_1.maybeOpenImageGallery)(editor, di);
            if (!didOpenGallery) {
                (0, WidgetActions_1.newParagraphBelowWidget)(editor);
            }
            return true;
        }),
        onDelete: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("imageDelete")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Delete)
            .inBlockType(EditorTypes_1.BlockType.Any)
            .notInBlockType(EditorTypes_1.BlockType.Image)
            .atEndOfBlock()
            .selectionIsCollapsed()
            .hasBlockAfter(EditorTypes_1.BlockType.Image)
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, Utils_1.moveToStartOfNextText)(editor);
            return true;
        }),
        onLeftKeyInEmptyImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onLeftKeyInEmptyImage")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.ArrowLeft)
            .inBlockType(EditorTypes_1.BlockType.Image)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            var madeMove = (0, ImageActions_1.maybeMoveBackwardsInImage)(editor);
            if (madeMove) {
                event.preventDefault();
            }
            return madeMove;
        }),
        onUpKeyInEmptyImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onUpKeyInEmptyImage")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.ArrowUp)
            .inBlockType(EditorTypes_1.BlockType.Image)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            var madeMove = (0, ImageActions_1.maybeMoveBackwardsInImage)(editor);
            if (madeMove) {
                event.preventDefault();
            }
            return madeMove;
        }),
        onRightKeyInEmptyImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onRightKeyInEmptyImage")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.ArrowRight)
            .inBlockType(EditorTypes_1.BlockType.Image)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            var madeMove = (0, ImageActions_1.maybeMoveForwardsInImage)(editor);
            if (madeMove) {
                event.preventDefault();
            }
            return madeMove;
        }),
        onDownKeyInEmptyImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDownKeyInEmptyImage")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.ArrowDown)
            .inBlockType(EditorTypes_1.BlockType.Image)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            var madeMove = (0, ImageActions_1.maybeMoveForwardsInImage)(editor);
            if (madeMove) {
                event.preventDefault();
            }
            return madeMove;
        }),
        onDragImageWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Drag image widget")
            .isEvent(EditorTypes_1.EventType.DragStart)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            return (0, ImageActions_1.maybeSetDragImageWidget)(editor, event, dragStore);
        }),
        onDropImageWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Drop image widget")
            .isEvent(EditorTypes_1.EventType.Drop)
            .doAction(function (event, editor) {
            return usingFeature(FeatureFlag_1.default.SidebarImages)
                ? (0, ImageActions_1.maybeDropImageWidget)(dragStore, dropLocationStore, editor)
                : (0, ImageActions_1.maybeDropImageWidgetWithoutDropIndicator)(dragStore, event, editor);
        }),
        onDragEndImageWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Drag end image widget")
            .isEvent(EditorTypes_1.EventType.DragEnd)
            .doAction(function () {
            if (dragStore.dragItemIfCurrent(DragStore_1.DragType.ImageWidgetFromEditor)) {
                dragStore.stopDrag();
                dropLocationStore.clearDropLocation();
                return true;
            }
        }),
        onDragOverHoldingImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDragImageFromSidebar")
            .isEvent(EditorTypes_1.EventType.DragOver)
            .doAction(function (event, editor) {
            var handled = (0, ImageActions_1.maybeUpdateImageDropLocation)(editor, event, dragStore, dropLocationStore);
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
            }
            return handled;
        }),
        onDropImageFromSidebar: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDropImageFromSidebar")
            .isEvent(EditorTypes_1.EventType.Drop)
            .doAction(function (event, editor) {
            var insertedImage = (0, ImageActions_1.maybeInsertImageFromSidebar)(editor, dragStore, dropLocationStore, mediaUsageReporter, blockStore.blockType, editorTelemetry);
            if (insertedImage) {
                event.preventDefault();
                contentSidebarTelemetry.sidebarAssetAdded(TelemetryEnums_1.SidebarAssetAddedType.Image, TelemetryEnums_1.SidebarAssetAddedInsertMethod.Drag);
            }
            return insertedImage;
        }),
    };
});
